<h4 class="text-center">
  {{message | cbsLabel}}
</h4>
